<template>
  <div class="w-full">
    <div class="flex flex-wrap gap-2.5">
      <div
        :title="t.label[locale as Locale]"
        @click="$emit('filter-by-art-type', t.key)"
        class="relative text-sm cursor-pointer border border-gray-200 bg-white transition-all w-fit rounded-lg duration-300 px-5 py-1 flex items-center justify-between"
        :class="t.key === artType ? 'bg-blue-50 text-blue-600' : ''"
        v-for="t in artTypes"
        :key="t.id"
      >
        <div class="flex items-center space-x-2">
          <Icon :name="t.icon" size="18" />
          <span>{{
            cutName(t.label[locale as Locale], width > 640 ? 100 : 100000)
          }}</span>
        </div>
        <button
          v-if="t.key === artType"
          class="cursor-pointer size-4 min-w-4 absolute -top-1 z-10 bg-white rounded-full border border-gray-200 shadow-2xl -right-1 flex items-center justify-center"
          title="Remove filter"
          type="button"
        >
          <Icon name="ph:x" size="10" />
        </button>
      </div>
      <slot name="sales-filter"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Locale } from "vue-i18n";
import { artTypes, type ArtType } from "~~/types/artwork";
import { useI18n } from "vue-i18n";
import { useWindowSize } from "@vueuse/core";
import { cutName } from "../../utils/helpers";

const { width } = useWindowSize();
const { locale } = useI18n();

defineEmits(["filter-by-art-type"]);

defineProps<{
  artType: ArtType;
  isForSale: boolean;
}>();
</script>
